import { AHText, TouchableBox, useLayoutContext } from "arkh";
import React, { useCallback, useEffect, useRef } from "react";
import { graphql, useFragment } from "react-relay";
import { DateTime } from "luxon";
import { FlatList } from "react-native";
import { ProductExpireBatchDatePicker_StoreProduct$key } from "./__generated__/ProductExpireBatchDatePicker_StoreProduct.graphql";
import { keyExtractorId } from "../../common/keyExtractors";

export const PRODUCT_EXPIRE_BATCH_DATE_PICKER_ITEM_WIDTH = 110;

export function ProductExpireBatchDatePicker(props: {
  product: ProductExpireBatchDatePicker_StoreProduct$key;
  selectedId: string;
  setSelectedId: (id: string) => void;
}) {
  const layout = useLayoutContext();
  const product = useFragment(
    graphql`
      fragment ProductExpireBatchDatePicker_StoreProduct on StoreProduct {
        activeExpireBatches {
          id
          expireAtDate {
            isoString
          }
        }
      }
    `,
    props.product
  );

  const initialScrollIndex = product.activeExpireBatches.findIndex(
    (b) => b.id === props.selectedId
  );

  type Item = (typeof product.activeExpireBatches)[number];

  const renderItem = useCallback(
    ({ item }: { item: Item }) => {
      return (
        <TouchableBox
          onPress={() => {
            props.setSelectedId(item.id);
          }}
          style={{
            height: layout.circle.xlarge,
            width: PRODUCT_EXPIRE_BATCH_DATE_PICKER_ITEM_WIDTH,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <AHText
            type="subtitle"
            color={
              item.id === props.selectedId ? "text-primary" : "text-washed"
            }
            spaceHorizontal="medium"
          >
            {DateTime.fromISO(item.expireAtDate.isoString).toFormat(
              "dd-MM-yyyy"
            )}
          </AHText>
        </TouchableBox>
      );
    },
    [layout.circle.xlarge, props]
  );

  const ref = useRef<FlatList>(null);

  useEffect(() => {
    if (
      initialScrollIndex !== undefined &&
      initialScrollIndex >= 0 &&
      ref.current
    ) {
      ref.current.scrollToIndex({
        index: initialScrollIndex,
        animated: false,
      });
    }
  }, [initialScrollIndex]);

  return (
    <FlatList
      ref={ref}
      horizontal
      data={product.activeExpireBatches}
      style={{
        width: "100%",
        height: layout.circle.xlarge,
        maxHeight: layout.circle.xlarge,
      }}
      getItemLayout={(_, index) => ({
        length: PRODUCT_EXPIRE_BATCH_DATE_PICKER_ITEM_WIDTH,
        offset: PRODUCT_EXPIRE_BATCH_DATE_PICKER_ITEM_WIDTH * index,
        index,
      })}
      keyExtractor={keyExtractorId}
      renderItem={renderItem}
    />
  );
}
